import React, { Component } from "react";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  table1: {
    margin: "20px",
    width: 700,
  },
  table2: {
    margin: "20px",
    width: 700,
  },
  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  boldCenterCell: {
    fontWeight: "bold",
    fontSize: 14,
    align: "center",
  },
});

class CdisbDetailDetails extends Component {
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let report = this.props.report;
    let checks = this.props.report.checks;
    let ach = this.props.report.ach;
    return (
      <div>
        <div style={{ marginTop: 30, marginLeft: 20 }}>
          <Typography variant="headline">
            &nbsp;{t("detailReportCdisb.label")}
          </Typography>
        </div>
        <table className={classes.table1}>
          <Paper elevation={6}>
            <tr>
              <td style={{ width: "120px" }}>
                {" "}
                <strong>&nbsp;{t("reportDate.label")}:</strong>
              </td>
              <td style={{ width: "330px" }}> {report.dateCreated}</td>
              <td style={{ width: "300px" }}>
                {" "}
                <strong>{t("createdBy.label")}:</strong> &nbsp;&nbsp;&nbsp;
                {report.userName}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>
                <strong>
                  {t("fundingFor.label")}:&nbsp;&nbsp;&nbsp;{report.dateCreated}
                </strong>
              </td>
            </tr>
            <br />
            <tr>
              <td style={{ width: "350px" }}>
                <strong>&nbsp;{t("companyName.header")}</strong>
              </td>
              <td style={{ width: "200px" }}>
                <strong>{t("transit.header")}</strong>
              </td>
              <td style={{ width: "200px" }}>
                <strong>{t("account.header")}</strong>
              </td>
            </tr>
            <tr>
              <td>&nbsp;{report.companyName}</td>
              <td>{report.transit}</td>
              <td>{report.account}</td>
            </tr>
          </Paper>
        </table>
        <div style={{ marginTop: 20, marginLeft: 20 }}>
          <Typography variant="h6">&nbsp;{t("checks.label")}</Typography>
        </div>
        <table className={classes.table}>
          <Paper elevation={6}>
            <TableHead>
              <td style={{ width: "120px" }}>{t("cheq.header")}</td>
              <td style={{ width: "120px" }}>{t("adjCheq.header")}</td>
              <td style={{ width: "120px" }}>{t("amount.label")}</td>
              <td style={{ width: "120px" }}>{t("adjAmount.header")}</td>
              <td style={{ width: "120px" }}>{t("suspect.header")}</td>
              <td style={{ width: "120px" }}>{t("returned.header")}</td>
              <tr style={{ height: "20px" }}></tr>
            </TableHead>
            <TableBody>
              {checks.map((n) => {
                return (
                  <tr>
                    <td>{n.presChnr}</td>
                    <td>{n.chnr}</td>
                    <td>{n.presAmount}</td>
                    <td>{n.amount}</td>
                    <td>{n.suspect}</td>
                    <td>{n.returned}</td>
                  </tr>
                );
              })}
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colsPan={5}>
                  <strong>{t("fundingReq.label")}</strong>
                </td>
                <td>
                  <strong>{report.outTotalChecks}</strong>
                </td>
              </tr>
            </TableBody>
          </Paper>
        </table>
        <div style={{ marginTop: 20, marginLeft: 20 }}>
          <Typography variant="h6">&nbsp;{t("elecTrans.label")}</Typography>
        </div>
        <table className={classes.table}>
          <Paper elevation={6}>
            <TableHead>
              <td style={{ width: "120px" }}>{t("trace.header")}</td>
              <td style={{ width: "120px" }}>{t("amount.label")}</td>
              <td style={{ width: "240px" }}>{t("paymentInfo.header")}</td>
              <td style={{ width: "120px" }}>{t("suspect.header")}</td>
              <td style={{ width: "120px" }}>{t("returned.header")}</td>
              <tr style={{ height: "20px" }}></tr>
            </TableHead>
            <TableBody>
              {ach.map((n) => {
                return (
                  <tr>
                    <td>{n.presChnr}</td>
                    <td>{n.presAmount}</td>
                    <td>{n.chnr}</td>
                    <td>{n.suspect}</td>
                    <td>{n.returned}</td>
                  </tr>
                );
              })}
              <tr style={{ height: "20px" }}></tr>
              <tr>
                <td colsPan={4}>
                  <strong>{t("fundingRequirement.label")}</strong>
                </td>
                <td>
                  <strong>{report.outTotalElectronic}</strong>
                </td>
              </tr>
            </TableBody>
          </Paper>
        </table>
        <table className={classes.table2}>
          <tr style={{ height: "20px" }}></tr>
          <tr>
            <td style={{ width: "600px" }}>
              <strong>{t("totalFundingReq.label")}</strong>
            </td>
            <td style={{ width: "120px" }}>
              <strong>{report.outTotalAmount}</strong>
            </td>
          </tr>
          <tr style={{ height: "20px" }}></tr>
          <tr>
            <td colSpan={2}>
              {" "}
              {t("totalRecords.label")}:{" "}
              {report.checks.length + report.ach.length}
            </td>
          </tr>
        </table>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CdisbDetailDetails));
